import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { ThinClose } from 'src/components/svg/Closes';

interface RecentSearchesProps {
  items: string[];
  handleClick: (search: string) => void;
  handleDelete?: (search: string) => void;
}

export const RecentSearches: FC<RecentSearchesProps> = ({ items, handleDelete, handleClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <h3 className="text-sm font-bold text-sm_recent_searches_history_text mt-3">
        {t('general.searchHistory')}
      </h3>
      <div className="overflow-x-auto flex gap-1 pb-1 mt-2.5">
        {items.map((item) => {
          const onCrossClick: MouseEventHandler<HTMLButtonElement> = (e) => {
            handleDelete?.(item);
            e.stopPropagation();
          };

          const onItemClick = () => {
            handleClick(item);
          };

          return (
            <div
              className="p-3 flex-none border-1 rounded-lg border-solid border-sm_recent_searches_border text-sm text-sm_recent_searches_text bg-sm_recent_searches_bg"
              key={item}
              onClick={onItemClick}>
              {item}
              <button className="p-1 ml-2.5" onClick={onCrossClick}>
                <ThinClose className="w-3 h-3" />
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
};
